angular.module('gym.components').directive('whatsOnTodayWidget', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/dashboard/whats_on_today_widget.html.slim'),
    scope: {
      privacyModeEnabled: '='
    },
    controller: ["$scope", "$rootScope", "$q", "Dashboard", "Calendar", "loadingAnimation", "EventService", function($scope, $rootScope, $q, Dashboard, Calendar, loadingAnimation, EventService) {
      var gym, load, loadEventDetails;
      gym = $rootScope.gym;
      $scope.isLoading = true;
      $scope.count = 5;
      load = function() {
        return Dashboard.all('whats_on_today').getList({
          count: $scope.count
        }).then(function(data) {
          $scope.isLoading = false;
          loadingAnimation.hide();
          $scope.data = data;
          return $scope.isMoreAvailable = data.meta.total > data.length;
        });
      };
      load();
      $scope.loadMore = function(count) {
        $scope.count = $scope.count + count;
        loadingAnimation.show();
        return load();
      };
      $scope.freeClassTooltipContent = `<div class="long-content-tooltip-inner">
  This event does not require an active membership to book, and prospects and cancelled members may attend.
  <br/>
  Bookings made against this event will not count against membership class limits.
</div>`;
      $scope.freeBookingTooltipContent = `<div class="long-content-tooltip-inner">
  Free bookings do not count against membership class limits.
</div>`;
      loadEventDetails = function(event) {
        return $q.all([Calendar.one('events', event.id).get(), EventService.getBookings(event.id)]).then(function(response) {
          event.waitlist = response[0].waitlist_attendees.collection;
          return event.bookings = response[1];
        });
      };
      $scope.toggleAttendees = function(event) {
        if (event.attendeesVisible) {
          return event.attendeesVisible = false;
        } else {
          event.attendeesVisible = true;
          event.waitlistVisible = false;
          return loadEventDetails(event);
        }
      };
      $scope.toggleWaitlist = function(event) {
        if (event.waitlistVisible) {
          return event.waitlistVisible = false;
        } else {
          event.attendeesVisible = false;
          event.waitlistVisible = true;
          return loadEventDetails(event);
        }
      };
      return $scope.viewEvent = function(event) {
        return EventService.showAttendees(event, {
          showCalendarLink: true
        });
      };
    }]
  };
});
